import { render, staticRenderFns } from "./InstructorIndexPage.vue?vue&type=template&id=54f25f70&scoped=true"
import script from "./InstructorIndexPage.vue?vue&type=script&lang=js"
export * from "./InstructorIndexPage.vue?vue&type=script&lang=js"
import style0 from "./InstructorIndexPage.vue?vue&type=style&index=0&id=54f25f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f25f70",
  null
  
)

export default component.exports